import React from 'react'
import Slider from "react-slick";
import { useEffect, useState, useCallback } from "react";
import Certifcates from '../../component/Certifcates';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";
import TopSection from '../../component/TopSection';


function BallisticPlates() {
  // const [nav1, setNav1] = useState();
  // const [nav2, setNav2] = useState();
  // const slider1 = useRef(null);
  // const slider2 = useRef(null);
  // useEffect(() => {
  //   setNav1(slider1.current);
  //   setNav2(slider2.current);
  // }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
      autoplaySpeed: 3000,
  };

  const location = useLocation();
  const slug = location.pathname.split("/")[1];
  console.log(slug)
  const [cat, setCat] = useState([])
  const API = `https://www.indianarmour.com/indianarmourcms/APIs/Product/index.php?category=${slug}`;
  const ImageURL = 'https://www.indianarmour.com/indianarmourcms/';
  const fetchPost = useCallback(() => {
    fetch(API)
      .then((res) => res.json())
      .then((res) => {
        console.log(res)
        setCat(res)
      })
  }, [API]);
  useEffect(() => {
    fetchPost()
  }, [fetchPost])

  const [data, setData] = useState([]);
  const pageAPI = `https://www.indianarmour.com/indianarmourcms/APIs/Mainproduct/index.php?page_name=${slug}`;
  const fetchData = useCallback(() => {
    fetch(pageAPI)
      .then((res) => res.json())
      .then((res) => {
        setData(res)
      })
  }, [pageAPI]);
  useEffect(() => {
    fetchData()
  }, [fetchData]);

  // Uses the backend schema when available; otherwise falls back to the home page organization schema
  useEffect(() => {
    if (!data?.[0]?.schema_content) return;

    const script = document.getElementById('organization-schema');
    if (script) script.remove();

    return () => {
      // Restores home page schema when navigating away or when backend schema is cleared
      if (!document.getElementById('organization-schema')) {
        const s = document.createElement('script');
        s.id = 'organization-schema';
        s.type = 'application/ld+json';
        s.text = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Indian Armour",
          "alternateName": "Indian Armour",
          "url": "https://www.indianarmour.com/",
          "logo": "https://www.indianarmour.com/images/logo.svg",
          "sameAs": [
            "https://www.facebook.com/indianarmoursystems/",
            "https://twitter.com/armour_indian",
            "https://www.instagram.com/indian_armour_systems/",
            "https://www.youtube.com/channel/UCXTbVLwSlwaSKsQoRV2E1RA",
            "https://www.linkedin.com/in/indian-armour-5b60a6188/"
          ]
        });
        document.head.appendChild(s);
      }
    };
  }, [data]);

  return (
    <div>
      <Helmet>
        <title>{data?.[0]?.meta_title}</title>
        <meta name="description" content={data?.[0]?.meta_desc} />
        <link rel="canonical" href={`https://www.indianarmour.com/${slug}`} />
        {data?.[0]?.schema_content && (
          <script type="application/ld+json">
            {data[0].schema_content}
          </script>
        )}
      </Helmet>


       <TopSection/>

      {/* Mich Ach Helmet with Accessories */}
      <section className="helmets-acces">
        <div className="container">
          <div className="helmets-acces-slider">
            <div className="slider-fors" data-aos="fade-up" data-aos-duration={1500}>
              <Slider {...settings} >

                {cat.map((item) => {
                  return (
                    <div>
                      <div className="helmets-acces-bg" style={{ backgroundImage: 'url("/images/Helmet-bg.png")' }}>
                        <div className="row">
                          <div className="col-lg-5">
                            <div className="helmets-img">
                              <img src={ImageURL + item.category_image} alt={item.heading} />
                            </div>
                          </div>
                          <div className="col-lg-7">
                            <div className="helmets-acce-text">
                              <h2>{item.heading}</h2>
                              <p>{item.category_content}</p>
                              <Link to={`../` + item.category_slug} className="know-more ">Read more <img src="/images/arrow.svg" alt="" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </Slider>
            </div>

              {/* <div className="slider-navs" data-aos="fade-up" data-aos-duration={1000}>
                <Slider asNavFor={nav1}
                  ref={slider2}
                  slidesToShow={3}
                  swipeToSlide={true}
                  focusOnSelect={true}
                  centerMode={true}
                  centerPadding="0"
                  
                >
                  {cat.map((item) => {
                    return (
                      <div>
                        <div className="helmet-sli">
                          <div className="fs-detail">
                            <img src={ImageURL + item.category_image} />
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </Slider>
              </div> */}

          </div>
        </div>
      </section>


    


        
 <section className='table-block pb-50'>
  <div className='container'>
     <div className='row'>
        <div className='col-lg-12'>
          <div className='table-responsive'>
            <table className='table table-bordered table-striped'>
          
    <thead>
      <tr>
        
        <th>Plate Name</th>
        <th>Protection Level</th>
        <th>Bullet Construction</th>
        <th>Bullet Type</th>
        <th>Weight Options</th>
      </tr>
    </thead>
    <tbody>
      <tr>
     
        <td><Link to='/product/armour-plate-level-iii-icw '>Valor Armour RF Elite</Link></td>
        <td>NIJ Level III ICW</td>
        <td>7.62X39MSC & 7.62X51 NATO</td>
        <td>NATO Ball, M80, SLR</td>
        <td>1.4 kg / 2.9 kg </td>        
      </tr>

      <tr>
       
        <td><Link to='/product/armour-platel-level-iii-standalone '>Valor Armour RF Elite</Link></td>
        <td>NIJ Level III Standalone</td>
        <td>7.62X39MSC & 7.62X51 NATO</td>
        <td>NATO Ball, M80, SLR</td>
        <td>1.7  kg / 3.2 kg</td>        
      </tr>

      <tr>
      
        <td><Link to='/product/armour-plate-level-iii-plus-icw'>Valiant Armour RF2</Link></td>
        <td>NIJ Level III+ ICW</td>
        <td>7.62 x 51 mm Lead Core <br/>7.62 x 39 mm Lead Core<br/>5.56 x 45 mm Lead Core</td>
        <td>NATO Ball, M80, SLR, <br/>L2A 2CJLC, MSC M193, L2A1</td>
        <td> 1.8 kg / 2 kg</td>        
      </tr>

      <tr>
       
        <td><Link to='/product/armour-plate-level-iii-standalone'>Valiant Armour RF2</Link></td>
        <td>NIJ Level III+ Standalone</td>
        <td>
          7.62 x 51 mm Lead Core<br/>
          7.62 x 39 mm Lead Core <br/>
          5.56 x 45 mm Lead Core
        </td>
        <td>NATO Ball, M80, SLR,<br/> L2A2 CJLC M193, L2A1</td>
        <td>2 kg / 2.2 kg
        </td>        
      </tr>

      <tr>
      
        <td><Link to='/product/armour-plate-level-iv-icw'>Bastion Armour RF3</Link></td>
        <td>NIJ Level IV ICW</td>
        <td>7.62 x 63 AP 7.62 x 54 API <br/>7.62 x 51 7.62 x 39 API</td>
        <td>M2AP Dragunov NATO M80 BZ</td>
        <td>2.65 kg / 3.2 kg</td>        
      </tr>

      <tr>
   
        <td><Link to='/product/armour-plate-level-iv-standalone'>Bastion Armour RF3</Link></td>
        <td>NIJ Level IV Standalone</td>
        <td>7.62 x 63 AP 7.62 x 54 API <br/>7.62 x 51 7.62 x 39 API</td>
        <td>M2AP Dragunov NATO M80 BZ</td>
        <td>2.7 kg / 3.6 kg</td>        
      </tr>

      
     
    </tbody>
  </table>
         
          </div>
        </div>
      </div>    
  </div>
 </section>

       <section className="view-all-product">
          <div className="container">
            <div className="row">
              <div className="view-all-btn">
                <div className="input-group mb-5">
                  <a href={"ProductList/"+slug} className="btn know-more-btn submit">View All Products
                    <span className="input-group-text"><img src="/images/arrow.svg" alt="" /></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      {/* Mich Ach Helmet with Accessories */}
      <section className='range pb-5'>
       <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
            <h2 className='heading'>Our Ballistic Plates Range Has Something For Everyone!</h2>
            <p>Whether you are a special forces operative on a counterterrorism mission, a law enforcement officer assigned to handle internal differences, or a VIP looking for a coveted body armour, we've got you covered. Based on the needs of your mission, you can select the ballistic plate which suits you best. </p>
            <p>The ballistic plates range at Indian Armour encompasses plates providing NIJ protection levels III (Valor), III+ (Valiant), and IV (Bastion). You also have the option of choosing between Standalone and ICW (In Conjunction With) plates for all three series - Valor Armour RF Elite, Valiant Armour RF2, and Bastion Armour RF3.
</p>
          </div>
        </div>
       </div>
      </section>
      {/* Ballistic Helmets by Indian Armour */}
      <section className="helmets-in-armour" style={{ backgroundImage: 'url("/images/ballistic-vest-bg.png")' }}>
        <div className="container">
          <div className="helmets-in-he">
            <h2>Ballistic Plates by Indian Armour</h2>
          </div>
          <div className="row">
            <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
              <div className="helmet-in-text" data-aos="fade-right">
                <p>Hard armour plates, usually known as (HAP) work in conjunction with the interior armour pack to stop a bullet from penetration or stand alone in a plate carrier vest. These hard armour plates provide protection against high-velocity rounds. Our hard armour plates offer better resistance against Lead Core and Mild steel core bullets and are made with special varieties of materials like Ultra High Molecular Weight Polyethylene, Aramid, ceramics or a compound solution of all these materials together. Indian Armour’s bullet resistant panels are lightweight and engineered with ‘energy dissipation mechanism and provide protection from high-caliber rifles. The high strength and low-density solution make our plates extremely durable and lightweight along with ample mobility and endurance.</p>
                <p>Our Ceramic Plates are specifically engineered to be strong enough to provide resistance to a bullet upon impact and challenge any sort of material penetration. These offer an advantage over steel, being extremely lightweight while offering maximum energy absorption. Our Ceramic plates are manufactured using quality materials such as boron carbide, silicon carbide, titanium boride etc. We offer Hard armour plates for threat level against NIJ level III (Valior Armour RF Elite), NIJ level III+ (Valiant Armor RF2), and NIJ level Level IV (Bastion Armour RF3) for stand alone protection and in conjunction with. Our hard armour plates undergo stringent testing in house and NIJ accredited international laboratories to ensure optimum ballistic performance. We rigorously keep conducting Research & Development to design and manufacture even lighter and stronger plates to withstand the emerging threats.</p>

              </div>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
              <div className="helmet-in-img" data-aos="fade-left">
                <img src="/images/ballistic-vest-right.png" className='img-fluid' alt='ballistic plates' />
                
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Ballistic Helmets by Indian Armour */}
      {/* tabint */}
      {/* tabint */}
      <section className="new-tabing">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="new-tabing-box1" data-aos="zoom-in">
                <p>Our Ceramic Plates are specifically engineered to be strong enough to smash a bullet upon impact and challenge any sort of material penetration. These offers an advantage over steel being extremely lightweight while offering maximum energy absorption. Our Ceramic plates are manufactured using quality materials such as boron carbide, silicon carbide, titanium boride etc.</p>
                <p> We offer Hard armour plates for threat level against NIJ level III, III Plus to Level IV Armour Plate  for stand alone protection and in conjunction with.</p>
                <p> Our hard armour plates undergo stringent testing in house and NIJ accredited international laboratories to ensure optimum ballistic performance. We rigorously keep conducting Research & Development to designing and manufacturing even lighter and stronger plates to withstand the threats future battlefields.</p>
              </div>
            </div>
          </div>
          {/* <div className="new-tabing-box2">
          <div className="row">
            <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
              <div className="new-tabing-box2-img ballistic-armour-box-img" data-aos="fade-right">
                <img src="/images/Helmet-2.png" />
              </div>
            </div>
            <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
              <div className="new-tabing-box2-text" data-aos="fade-left">
                <div className="accordion" id="accordionExample1">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne1-1">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne1-1" aria-expanded="true" aria-controls="collapseOne1-1">
                      Tactical Helmet, The latest advancements in relation to its materials
                      </button>
                    </h2>
                    <div id="collapseOne1-1" className="accordion-collapse collapse " aria-labelledby="headingOne" data-bs-parent="#accordionExample1">
                      <div className="accordion-body">
                        <p>
                        A Tactical helmet is designed to protect the wearer during tactical situations. These helmets were originally designed for the military, but since then they have made their way into law enforcement and other relevant services. Its application has managed to evolve over the previous century, from blocking shrapnel to stopping bullets.
                        </p>
                        <p> In the 1970s, Dupont™ launched Kevlar®, a lightweight fabric material that has now been regarded as protective armour. Teijin™ is yet another well-known manufacturer of ballistic fabric materials, featuring Twaron® fibres. Modern helmets come with a variety of padding solutions for added comfort, as well as a range of accessories and extensions. </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo1-2">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo1-2" aria-expanded="false" aria-controls="collapseTwo1-2">
                      Situations might necessitate the use of a ballistic helmet
                      </button>
                    </h2>
                    <div id="collapseTwo1-2" className="accordion-collapse collapse" aria-labelledby="headingTwo-2" data-bs-parent="#accordionExample1">
                      <div className="accordion-body">
                        <p>
                        A ballistic helmet not only protects your delicate head, but also protects you from severe temperatures, fire, water, dampness, and ultraviolet (UV) radiation.
                        </p>
                        <p> Military, police forces, and other law enforcement agencies who are continuously exposed to potentially dangerous circumstances such as crossfires, riots, and wars are at a greater risk of injury and even death.</p>
                        <p>During natural disasters such as tornadoes and storms, internal or international attacks, rebellions, catastrophic events, and so on, a civilian will need to shield themselves from the worst calamities. Ballistic helmets can be considered a vital protective gear during rescue operations in such disasters.</p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo1-3">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo1-3" aria-expanded="false" aria-controls="collapseTwo1-3">
                      Military helmets. level of protection can a ballistic helmet offer
                      </button>
                    </h2>
                    <div id="collapseTwo1-3" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample1">
                      <div className="accordion-body">
                        <p>
                        Ballistic helmets are designed to protect the wearer’s head from shrapnel, weapons such as artillery, bombs, rockets, hand-thrown grenades, satchel charges, and other explosives. Depending on the NIJ threat levels for which it is designed, ballistic helmets protect against different types of handguns. <br />Other blunt objects, such as the edge of a rifle, the swing of a handheld hammer, or a sharp blade, might seriously harm or kill the victim, but a tactical helmet will protect the user from such blunt force strikes and injuries.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo1-4">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo1-4" aria-expanded="false" aria-controls="collapseTwo1-4">
                      A perfect ballistic helmet for you
                      </button>
                    </h2>
                    <div id="collapseTwo1-4" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample1">
                      <div className="accordion-body">
                        <p>
                        The perfect ballistic helmet protects your life while still allowing you to operate comfortably and spontaneously. The bulletproof helmets are not completely bulletproof, and the modern helmets offer varying degrees of protection depending on the NIJ level to which they are tested. A perfect ballistic helmet will free your hands by incorporating cameras, lights, and other features on the helmet based on your needs, protecting against head injuries such as collisions and providing a wide range of benefits such as protection against shrapnel, impacts from the edge of a rifle, and so on.
                        </p>
                        <p>Furthermore, the psychological impact of wearing a helmet should not be overlooked. Feeling safer and knowing what your advantages are could also enhance your confidence and help you focus better on the task at hand.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
          {/* Certificates */}
          <Certifcates></Certifcates>
          {/* Certificates */}
        </div>
      </section>
      {/* tabint */}
      {/* faq */}
      <section className="faq-sec">
        <div className="container">
          <div className="faq-he">
            <h2>Frequently asked questions</h2>
          </div>
          <div className="row">
            <div className="faq-accordion">
              <div className="row">
                <div className="col-lg-6" data-aos="fade-right" data-aos-offset={300}>
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                          How effective are ballistic plates?
                        </button>
                      </h2>
                      <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample" style={{}}>
                        <div className="accordion-body">
                          <p>    Ballistic plates are effective in stopping bullets as per their rated protection levels such as NIJ Level 3 or NIJ Level 4.</p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingTwo">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          What ballistic plates does the army use?
                        </button>
                      </h2>
                      <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          <p>
                            The army uses ballistic plates of either NIJ Level 3 or Level 4 protection, and these may be in an “In-Conjunction With (ICW) soft armour” type or it may be in a Standalone (STA) type.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="heading3">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapseTwo">
                          Can bulletproof vest stop ak47?
                        </button>
                      </h2>
                      <div id="collapse3" className="accordion-collapse collapse" aria-labelledby="heading3" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          <p>
                            A bulletproof vest which has hard armour can resist bullet penetrations fired from an AK-47 rifle, but this ultimately also depends upon the specification of the bullet as well.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /col-lg-6 */}
                <div className="col-lg-6" data-aos="fade-left" data-aos-offset={300}>
                  <div className="accordion" id="accordionExample3">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne1-1">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne1-1" aria-expanded="true" aria-controls="collapseOne1-1">
                          What are ballistic plates made out of?
                        </button>
                      </h2>
                      <div id="collapseOne1-1" className="accordion-collapse collapse " aria-labelledby="headingOne" data-bs-parent="#accordionExample3">
                        <div className="accordion-body">
                          <p>
                            Ballistic plates are made out of composite materials such as UHMWPE, Aramid and ceramics such as Silicon Carbide or Boron Carbide. These materials act together to stop bullets and fragments from penetrating the wearer.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingTwo1-2">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo1-2" aria-expanded="false" aria-controls="collapseTwo1-2">
                          How much do ballistic plates weight?
                        </button>
                      </h2>
                      <div id="collapseTwo1-2" className="accordion-collapse collapse" aria-labelledby="headingTwo-2" data-bs-parent="#accordionExample3">
                        <div className="accordion-body">
                          <p>
                            Ballistic plates can vary between 1 kg to up to 3.6kg depending upon their rated protection level and whether they are classified as an “In-Conjunction With (ICW)” or “Standalone (STA)” plate.
                          </p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                {/* /col-lg-6 */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default BallisticPlates